import { createSlice } from '@reduxjs/toolkit';
import { homepageApi } from '../api/homepageApi';

const initialState = {
  roles: [],
  userRoles: [],
  allowedResources: []
};

const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      homepageApi.endpoints.getUserEntitlements.matchFulfilled,
      (state, action) => {
        state.roles = action.payload?.roles || [];
        state.userRoles = action.payload?.userRoles || [];
        state.allowedResources = action.payload?.allowedResources || [];
      }
    );
  }
});

export const reducer = entitlementsSlice.reducer;

export const selectEntitlements = (state) => state.entitlements;
export const selectRoles = (state) => state.entitlements.roles;
export const selectUserRoles = (state) => state.entitlements.userRoles;
export const selectAllowedResources = (state) => state.entitlements.allowedResources;
